import { Component, useRef } from 'react';
import { Accordion, Grid, Icon, Segment } from 'semantic-ui-react';
import { useWikiSearch } from '../WikiSearchContext';
import useHighlightMatches from '../useHighlightMatches';

class ParentGuardianHandbookClass extends Component {
  state = {
    activeIndex: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;

    const newIndex = activeIndex.includes(index)
      ? activeIndex.filter((i) => i !== index)
      : [...activeIndex, index];

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const { contentRef } = this.props;

    return (
      <div ref={contentRef}>
        <Grid id="detailed-segment">
          <Grid.Column width={16}>
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Accordion styled fluid id="segment" exclusive={false}>
                  <Accordion.Title
                    active={activeIndex.includes(0)}
                    index={0}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Welcome to React
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(0)}>
                    <h5>Welcome</h5>
                    <p id="orange">Welcome to React Behavioral Health.</p>
                    <p id="orange">
                      On behalf of the entire React team, we would like to
                      welcome you to the family and look forward to working with
                      you and your child.
                    </p>
                    <p id="orange">
                      Towards the end of 2018, we set out to create an agency
                      that would advance behavioral health and provide the
                      greatest level of care for children with Autism and other
                      behavioral needs. Before this could happen, we knew that
                      we had to first create a foundation that was designed to
                      foster that greatness in every team member, including you
                      and your family. We wanted to create a place where
                      passionate individuals are empowered to put their best
                      work forward in order to make a meaningful impact on the
                      children who need our services.
                    </p>

                    <p id="orange">
                      As a parent, we know how difficult it can be to open up
                      your door to strangers, especially when it regards your
                      children. We focus heavily on developing a relationship
                      with our families built on trust and comfortability first
                      and foremost. We also understand that this process can be
                      an adjustment and it may take some time to truly feel
                      comfortable. It is for this reason that we rely on
                      constant communication and feedback regarding all aspects
                      of services. You will be the most important team member
                      throughout this process and we will be relying on you to
                      assist us with providing the best possible service for
                      your child.
                    </p>

                    <p id="orange">
                      This handbook has been developed as a guide to the
                      policies, procedures, and expectations of all families
                      served by our agency. Please read through everything in
                      this handbook carefully and thoroughly. If you are unsure
                      about anything, please do not hesitate to ask for
                      clarification.
                    </p>

                    <h5>Who We Are</h5>
                    <p id="orange">
                      React’s mission is to advance behavioral health in order
                      to provide the greatest level of care for those with
                      Autism and other behavioral needs. We are focused solely
                      on the quality of the service we provide and strive to
                      create meaningful relationships with families, employees,
                      and community resources. We value the opinions and ideas
                      of every member of the team and recognize that this
                      service is most effective with a strong team-based
                      approach.
                    </p>

                    <h5>Who We Are</h5>
                    <ol id="blue">
                      <li>Support the abilities of all individuals</li>
                      <li>
                        Create an environment where all communication is valued
                      </li>
                      <li>
                        Respect all individuals & help people build off of their
                        strengths
                      </li>
                      <li>Continually look for ways to improve</li>
                      <li>Operate as efficiently as possible</li>
                      <li>
                        Use scientifically based research to guide our services
                      </li>
                      <li>
                        Create an environment of continued learning and training
                      </li>
                      <li>Give back to the communities that support us</li>
                      <li>Support other providers in our field</li>
                    </ol>

                    <h5>Our Service</h5>
                    <p id="orange">
                      React Behavioral Health is a Section 28 behavioral health
                      agency funded by the state of Maine. Section 28 services
                      are non-specialized, in-home treatment services designed
                      to improve functional skills relating to social
                      development, communication, safety awareness, and daily
                      living.
                    </p>
                    <p id="orange">
                      The direct-care team members involved with these services
                      are the client, the client’s family, the Behavioral Health
                      Professional, and the supervising Program Manager. The
                      indirect team members include the family’s natural
                      supports, React’s Program Development team, and all other
                      supporting team members of the family (such as Case
                      Management, medical professionals, etc).
                    </p>
                    <p id="orange">
                      Behavioral Health Professionals (BHPs) are the team
                      members that are working directly with the children. Using
                      an Individualized Treatment Plan created by the Program
                      Development team, the BHP will work on personalized goals
                      using methods and strategies developed by the treatment
                      team.
                    </p>
                    <p id="orange">
                      Each family will be assigned a Program Manager to
                      supervise the services being provided. Program Managers
                      meet and connect with both the family as well as the BHP
                      and oversee everything that is occurring. Program Managers
                      should be the first line of contact for all BHPs and
                      families if there is ever a problem, question, or concern.
                    </p>
                    <p id="orange">
                      The Program Development team will be the initial contact
                      for every family and helps to create an ideal treatment
                      plan for each individual client. Program Development team
                      members are directly involved with all services for all
                      children for the entirety of the plan. Families are
                      encouraged to reach out to any member of upper management
                      if they are not able to contact their Program Manager or
                      if they would like to talk to somebody other than their
                      Program Manager.
                    </p>

                    <h5>Service Outline</h5>
                    <p id="orange">
                      Our services begin through onboarding, which is led by our
                      Program Development (PD) team. Here we aim to establish a
                      rapport with families, determining their strengths and
                      needs and then coordinating which BHPs would be the most
                      beneficial to that clients progression. During this time,
                      we will conduct any needed assessments and gather
                      information to create an Individualized Treatment Plan, as
                      well as discuss our approach and vision for services with
                      that family.
                    </p>
                    <p id="orange">
                      After the initial onboarding, we will then determine which
                      Program Manager and BHP would be the best fit. Our Program
                      Manager and BHP will then familiarize themselves with the
                      background information and needs of the client before
                      having a meet and greet with the family. Our BHPs will
                      have access to more comprehensive trainings and techniques
                      before and after they begin serving clients. We will
                      require BHPs to complete Module 1 of the BHP Certification
                      course within 30 days of being hired. We believe all
                      employees benefit greatly from trainings and being BHP
                      Certified, so BHPs are encouraged to complete their BHP
                      Certification within 3 to 6 months. They will be given up
                      to a year to do so. In addition to BHP certification, BHPs
                      are also required to pass a Mandated Reporter training,
                      CPR class, Bloodborne Pathogens training, and proper
                      training on car seat safety.
                    </p>
                    <p id="orange">
                      Our software application, the React Portal, will be used
                      to document each session our BHPs work with a client. This
                      will enable the entire team to stay connected to how each
                      session went and also offer that BHP the opportunity to
                      reach out for guidance and help. This makes documentation
                      much more usable and accessible. The React Portal will
                      also be used for Supervisions, Individual Treatment Plans
                      (ITPs), tracking available client hours, and much more.
                      The React Portal is continually being updated, so let us
                      know if you have any ideas or suggestions.
                    </p>

                    <h5>Our Team</h5>
                    <div>
                      <blockquote id="blue">
                        <b id="green">Becky Shorey</b>
                        <br />
                        <span>Office Manager</span>
                        <br />
                        <span>p: 207-502-3445</span>
                        <br />
                        <span>e: becky@reactbh.org</span>
                      </blockquote>
                      <blockquote id="blue">
                        <b id="green">Cassandra Carr</b>
                        <br />
                        <span>Program Manager</span>
                        <br />
                        <span>p: 207-502-2306</span>
                        <br />
                        <span>e: cassandra@reactbh.org</span>
                      </blockquote>
                      <blockquote id="blue">
                        <b id="green">David Hansen</b>
                        <br />
                        <span>CEO/Program Development Director</span>
                        <br />
                        <span>p: 207-604-0342</span>
                        <br />
                        <span>e: david@reactbh.org</span>
                      </blockquote>
                      <blockquote id="blue">
                        <b id="green">Leanne Kelley</b>
                        <br />
                        <span>Program Manager</span>
                        <br />
                        <span>p: TBD</span>
                        <br />
                        <span>e: leanne@reactbh.org</span>
                      </blockquote>
                      <blockquote id="blue">
                        <b id="green">Pedro Revolorio</b>
                        <br />
                        <span>CTO</span>
                        <br />
                        <span>p: 207-502-2057</span>
                        <br />
                        <span>e: pedro@reactbh.org</span>
                      </blockquote>
                      <blockquote id="blue">
                        <b id="green">Wendy Johnson</b>
                        <br />
                        <span>Program Manager</span>
                        <br />
                        <span>p: 207-502-3445</span>
                        <br />
                        <span>e: wendy@reactbh.org</span>
                      </blockquote>
                      <h5>Licenses/Certifications</h5>
                      <p id="orange">
                        Our team founding team has over 25 years of combined
                        experience and understands the challenges faced by
                        clients, parents, and behavioral health providers. We
                        are officially licensed to provide this service in the
                        state of Maine, and parents and guardians are entitled
                        to view the current licensure and supporting documents
                        when requested.
                      </p>
                      <h5>Hours of Operation</h5>
                      <p id="orange">
                        Our office is open Monday through Friday, from 10am
                        until 4pm, unless otherwise stated in advance. BHPs are
                        able to work any day of the week, including weekends.
                        Our office will be closed on the following holidays:
                      </p>
                      <ul id="blue">
                        <li>New Years Day</li>
                        <li>Good Friday/Easter Monday</li>
                        <li>Memorial Day</li>
                        <li>Independence Day</li>
                        <li>Labor Day</li>
                        <li>Veterans Day</li>
                        <li>Thanksgiving Day</li>
                        <li>Christmas Eve</li>
                        <li>Christmas Day</li>
                      </ul>
                    </div>

                    <h5>Emergency Closings</h5>
                    <p id="orange">
                      In the event of a natural disaster or other emergency
                      closings, Program Managers will notify their BHPs, our
                      Office Manager will update our social media page, and we
                      will offer resources such as hotline information for those
                      that may need it. During emergencies and disasters,
                      services are not to be provided.
                    </p>

                    <h5>Emergency Closings</h5>
                    <p id="orange">
                      In the event of a natural disaster or other emergency
                      closings, Program Managers will notify their BHPs, our
                      Office Manager will update our social media page, and we
                      will offer resources such as hotline information for those
                      that may need it. During emergencies and disasters,
                      services are not to be provided.
                    </p>

                    <h5>Events</h5>
                    <p id="orange">
                      React offers events for clients, BHPs and families. These
                      events range from arts and crafts at our office to group
                      hikes in the surrounding areas. Most events will be
                      cost-free. However, if an event requires financial
                      contributions and/or additional contributions (packed
                      lunch, transportation, supplies, etc), it will be
                      communicated to both BHPs and families in advance. If any
                      contributions are difficult or unable to be provided,
                      please do not hesitate to contact a member of management
                      and we will assist in whatever way possible.
                    </p>

                    <h5>Client Safety</h5>
                    <p id="orange">
                      A safety plan will be created at the intake meeting for
                      all clients. A list of emergency contacts, health needs,
                      and safety concerns will be addressed, as well as a Crisis
                      Plan put in place if the family and/or provider deem it
                      necessary. These safety tools will be on file for the
                      agency and necessary information will be given to the
                      assigned BHP in case of emergency while on shift.
                    </p>

                    <h5>Client Illness</h5>
                    <p id="orange">
                      There are certain circumstances where a child’s illness or
                      medical emergency will inhibit services. If a child does
                      not attend school, services are not allowed to be provided
                      that day. Missed hours are allowed to be made up after
                      approval of the client’s supervisor. If a child attends a
                      doctor’s appointment and is deemed infectious for any
                      period of time, services are not to be provided during
                      that length of time. If a client’s illness threatens the
                      health of an employee of the agency, we will be required
                      to halt services until deemed safe by a doctor. If a
                      situation is deemed unsafe for an extended period of time,
                      we will be required to begin the steps of transitioning
                      the assigned BHP out of the home.
                    </p>

                    <h5>Discipline and Guidance</h5>
                    <p id="orange">
                      Our BHPs are trained and encouraged to use Evidence-Based
                      Practices to provide treatment, and we also use ABA
                      principles to shape how we provide service. We recognize
                      that every child is different, which contributes to a
                      fluctuation in discipline and guidance. We originate with
                      strategies and methods of treatment by first asking the
                      family and supports what is known to work and what is not.
                      We use this information to develop strategies and goals of
                      treatment. We ensure that guardians, BHPs, and supervisors
                      are directly involved with methods used throughout
                      treatment in order to evolve during service to provide the
                      best quality to the child. Some methods used are
                      redirection, repetition, discussion of cause and effect,
                      time away, positive rewards, restricted access, and token
                      systems, among others.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(1)}
                    index={1}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Covered Services
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(1)}>
                    <h5>
                      The company, as a Section 28 service, will supply the
                      following to each client:
                    </h5>
                    <ul id="blue">
                      <li>
                        Creation and implementation of an Individualized
                        Treatment Plan, updated every 6 months
                      </li>
                      <li>
                        Administration of a Comprehensive Assessment, updated on
                        an annual basis
                      </li>
                      <li>Plan for Discharge</li>
                      <li>Crisis/Safety Plan</li>
                      <li>Weekly Progress Notes</li>
                      <li>
                        Methods and strategies for making progress towards
                        outlined goals
                      </li>
                      <li>Constant open lines of communication</li>
                      <li>
                        Access to community supports and appropriate resources
                      </li>
                    </ul>
                    <h5>
                      Below is the description of covered Section 28 services
                      from the Maine DHHS website:
                    </h5>
                    <p id="orange">
                      Treatment Services for Children with Cognitive Impairments
                      and Functional Limitations are medically necessary
                      treatment services for members under the age of twenty one
                      (21). Treatment services are designed to retain or improve
                      functional abilities which have been negatively impacted
                      by the effects of cognitive or functional impairment and
                      are focused on behavior modification and management,
                      social development, and acquisition and retention of
                      developmentally appropriate skills. Services include
                      problem solving activities in order to help the member
                      develop and maintain skills and abilities necessary to
                      manage his or her behavioral health treatment needs,
                      learning the social skills and behaviors necessary to live
                      with and interact with other community members and
                      independently, and to build or maintain satisfactory
                      relationships with peers or adults, learning the skills
                      that will improve a member’s self awareness, environmental
                      awareness, social appropriateness and support social
                      integration, and learning awareness of and appropriate use
                      of community services and resources.
                    </p>
                    <p id="orange">
                      Section 28 services do NOT cover services that are
                      primarily academic, vocational, social, recreational, or
                      custodial in nature. They do not cover any service during
                      a client’s regular sleeping hours. A maximum of 8 hours
                      may be worked in one day. These services may not be
                      provided at the same time as another Mainecare-reimbursed
                      service (Section 65, for example).
                    </p>
                    <p id="orange">
                      These services do not allow for hands-on intervention.
                      Employees are not allowed to restrain clients unless
                      themselves, the child, or a bystander is at risk of
                      injury. Employees are not allowed to administer
                      medications to clients or perform any other medical
                      action. If there is concern for possible safety risks, a
                      Crisis Plan should be implemented and a Safety Plan
                      determined.
                    </p>

                    <p id="orange">
                      To view any additional rules and regulations, please visit
                      the Maine DHHS website at
                      http://www.maine.gov/dhhs/ocfs/cbhs/provider/forms/section-28.html
                      or contact the DHHS Section 28 Resource Coordinator, Cathy
                      Register, at 207-822-2331 or cathy.register@maine.gov
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(2)}
                    index={2}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Rights of Recipients
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(2)}>
                    <h5>Rights of Recipients of Mental Health Services</h5>
                    <p id="orange">
                      This is an outline of the rights of recipients of mental
                      health services in the state of Maine. All families are
                      able to obtain a full copy of these rights through React,
                      or by accessing this website
                      https://www.maine.gov/dhhs/samhs/mentalhealth/rights-legal/recipients/193c001.pdf.
                      The Rights of Recipients of Mental Health Services ensures
                      that clients suffer no loss of basic human rights. These
                      rules allow individual rights to be identified and
                      protected when services are being provided.
                    </p>

                    <ol id="blue">
                      <li>
                        Recipients have the same human, civil and legal rights
                        as all citizens, including the right to live in a
                        community of their choice without constraints upon their
                        independence
                      </li>

                      <li>
                        Recipients have the right to be treated in the least
                        restrictive appropriate setting to meet their needs.
                      </li>
                      <li>
                        Recipients have the right to be notified of all rights
                        accorded them as recipients of services, by Maine
                        statute, these rules, the Bates v. Davenport Settlement
                        Agreement, if applicable, and associated policies.
                      </li>
                      <li>
                        Recipients have the right to assistance in the
                        protection of their rights.
                      </li>

                      <li>
                        Recipients have the right to due process with regards to
                        grievances.
                      </li>

                      <li>
                        Recipients have the right to due process with regards to
                        grievances.
                      </li>

                      <li>
                        Recipients have the right to confidentiality and to
                        access to their record.
                      </li>

                      <li>
                        Recipients have the right to be paid a fair wage for
                        work done.
                      </li>

                      <li>
                        Recipients have the right to refuse to participate in
                        experimentation and research without loss of services.
                      </li>

                      <li>
                        Recipients have the right to an individualized treatment
                        plan.
                      </li>

                      <li>
                        Recipients have the right to informed consent for all
                        treatment and/or services.
                      </li>
                    </ol>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(3)}
                    index={3}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Complaints or Grievances
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(3)}>
                    <h5>Complaints</h5>
                    <p id="orange">
                      If React is not meeting standards or services are not
                      being provided as expected, parents are encouraged to
                      speak up. Please report any grievances in writing with
                      your Program Manager. If your Program Manager cannot be
                      reached, or if the situation involves your Program
                      Manager, the grievance should be reported to the CEO,
                      Pedro Revolorio, or the COO, David Hansen. All grievances
                      are reviewed and parents will be contacted after review.
                    </p>
                    <h5>Open-Door Policy</h5>
                    <p id="orange">
                      The company operates with an open-door policy, which gives
                      parents and guardians access to all levels of management
                      regarding any questions, issues, or feedback.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(4)}
                    index={4}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Boundaries & Accepting or Giving Gifts
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(4)}>
                    <h5>Gifts</h5>
                    <p id="orange">
                      Family members and clients are not to give any gifts,
                      gratuities or tips to employees, and family members and
                      clients are not to accept any gifts or gratuities from
                      employees.
                    </p>

                    <h5>Boundaries</h5>
                    <p id="orange">
                      Family members involved in treatment are required to
                      maintain appropriate boundaries with members employed by
                      the Company. These requirements indicate a strict
                      professional relationship. Some prohibited actions
                      include:
                    </p>

                    <ul id="blue">
                      <li>
                        Acknowledging and/or accepting any “friendship” on any
                        social media platform
                      </li>
                      <li>
                        Participating in any personal outing outside of
                        treatment parameters (birthday party, family outings,
                        personal shopping, etc)
                      </li>
                      <li>
                        Spending time with one another outside of work hours or
                        without the child present
                      </li>
                      <li>
                        Disclosure of personal matters not applicable to the
                        child
                      </li>
                      <li>
                        Completion of any personal errands not required for job
                        performance
                      </li>
                      <li>
                        Any romantic or personal relationship with an employee
                      </li>
                      <li>Any contact unrelated to treatment or service</li>
                    </ul>

                    <p id="orange">
                      Any violation of these requirements is subject to
                      reporting at the highest level. If there are questions
                      about specific activities or scenarios, please contact
                      your direct supervisor or another member of the management
                      team.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(5)}
                    index={5}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Mandated Reporting
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(5)}>
                    <h5>What is a Mandated Reporter?</h5>
                    <p id="orange">
                      All BHPs will have to complete a mandated reporting
                      curriculum before providing services. As mandated
                      reporters, our BHPs are required to report any evidence or
                      suspicion of abuse, neglect, or exploitation of a child
                      directly to their supervisor, immediately.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(6)}
                    index={6}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Expectations of Employees
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(6)}>
                    <p id="orange">
                      We are an equal opportunity employer and it is our policy
                      to hire all qualified personnel without regard to race,
                      religion, sex, color, age, disability, or national origin.
                      This agency complies with specifications of Title VII of
                      the Civil Rights Act of 1964, the Rehabilitation Act of
                      1973, the Age Discrimination in Employment of 1967, the
                      Pregnancy Discrimination Act of 1978 and the Equal Pay Act
                      of 1963.
                    </p>

                    <p id="orange">
                      All Behavioral Health Professionals are required to be of
                      18-years of age with a high school diploma or equivalent.
                      All BHPs are subjected to background and driving record
                      checks prior to employment. Prior to starting direct care
                      to an individual client, all BHPs are required to complete
                      an orientation outlining job duties and company policies,
                      a shadow shift designed to view first hand what the job
                      entails, mandated reporter training, and Module 1 of the
                      Behavioral Health Professional certification course.
                      Within 1 year of hire, every BHP is required to complete
                      the entirety of this certification course.
                    </p>

                    <p id="orange">
                      All employees are required to abide by the following
                      policies:
                    </p>

                    <h5>Non-solicitation Policy</h5>
                    <blockquote id="orange">
                      React prohibits the solicitation, distribution and posting
                      of materials on or at Company property by any employee or
                      non-employee, except as may be permitted by this policy.
                      The sole exceptions to this policy are charitable and
                      community activities supported by Company management and
                      Company-sponsored programs related to Company services.
                      Solicitation from a client, client’s family, or any other
                      client-associated entity of an employee of money, gifts,
                      loans, etc are not permitted.
                    </blockquote>

                    <h5>Employee and Employer Confidentiality Agreement</h5>
                    <blockquote id="orange">
                      The Company will maintain the confidentiality of
                      “protected health information” or “PHI” as defined by the
                      Health Insurance Portability and Accountability Act of
                      1996 (HIPAA). The Company will also maintain the
                      confidentiality of other information that is deemed to be
                      confidential by other laws. This information may include,
                      but is not limited to, information on clients, employees,
                      or financial and business operations. Confidential
                      information may include, but is not limited to, written,
                      electronic, oral, overheard or observed information.
                      Access to all information is granted on a need to know
                      basis which is information that is required to complete
                      your job requirements. Confidential information should not
                      be discussed with anyone, including, but not limited to,
                      clients, co-workers, other families, your family or your
                      friends. You must not discuss confidential information in
                      an environment where others may overhear. Disclosure of
                      confidential information is grounds for disciplinary
                      action up to and including termination. Any and all
                      records must be returned to the Company upon termination
                      of your employment.
                    </blockquote>

                    <h5>Attendance Expectations & Policy</h5>
                    <blockquote id="orange">
                      Employees are required to be at all shifts as scheduled.
                      Absences and tardiness interfere with the functioning of
                      the client’s care and program. It is their responsibility
                      to immediately notify their Supervisor as well as their
                      client’s family of their absence and/or tardiness. If an
                      employee desires to leave work for any reason during the
                      workday, the employee must obtain the approval of his or
                      her supervisor prior to leaving. The Company may require a
                      physician’s note for an excess of two (2) consecutive work
                      days and reserves the right to require an employee to
                      furnish a physician’s note for each sick day following the
                      use of three (3) sick days in a calendar year. It is their
                      responsibility to maintain communication - Supervisors and
                      families will not attempt to track them down. Any
                      unauthorized absence of two (2) or more work days shall be
                      considered an abandonment of employment and a voluntary
                      resignation. Excessive absenteeism or tardiness may
                      subject the employee to disciplinary action, up to and
                      including termination. Families are asked to communicate
                      any concerns or information regarding this policy and
                      their BHP.
                    </blockquote>

                    <h5>Work Dress Code</h5>
                    <blockquote id="orange">
                      Employees represent the Company whenever they come in
                      contact with the public, therefore the dress of staff
                      should be appropriate and suited to the job they are
                      performing. Employees should not wear large piercings or
                      earrings as they could be a safety concern and
                      inappropriate tattoos must be concealed at all times.
                    </blockquote>

                    <h5>Smoke-Free Workplace</h5>
                    <blockquote id="orange">
                      The Company has been declared a tobacco-free workplace and
                      tobacco is not permitted on agency grounds. Under no
                      circumstances should an employee smoke in the presence of
                      a client.
                    </blockquote>

                    <h5>Drugs and Alcohol: Drug-Free Workplace</h5>
                    <blockquote id="orange">
                      The Company is committed to providing a safe, productive
                      and drug-free workplace. We have a drug-free workplace
                      policy to ensure the safety of employees and the clients
                      we serve. Employees found violating this policy will be
                      subject to disciplinary action up to and including
                      termination. Any employee who has been convicted of a
                      drug-related or substance abuse charge will face
                      disciplinary action up to and including termination.
                    </blockquote>

                    <h5>Workplace Violence</h5>
                    <blockquote id="orange">
                      The Company is committed to providing a safe and secure
                      workplace free from physical violence, threats and
                      intimidation. Violence is a serious form of misconduct and
                      may result in disciplinary action up to and including
                      termination and/or other legal action.
                    </blockquote>

                    <h5>Safety and Security</h5>
                    <blockquote id="orange">
                      Any vehicle, locker, desk, office or containers that are
                      agency property as well as backpacks, briefcases, etc are
                      subject to inspection and search for cause by Company
                      management or their designated agents.
                    </blockquote>

                    <h5>Workplace Visitors</h5>
                    <blockquote id="orange">
                      Employees are asked to discourage friends and family from
                      visiting them on the job as this can compromise the
                      confidentiality of a client. At no time should employment
                      duties be compromised to greet a visitor.
                    </blockquote>

                    <h5>Conflicts of Interest</h5>
                    <blockquote id="orange">
                      The Company recognizes that the employment of individuals
                      who have existing relationships with employees or clients
                      (relatives, friends, etc) in certain circumstances can
                      disrupt the Company’s operations. When the Company
                      determines these problems will be present, it will decline
                      to hire an individual to work in the same department or in
                      any capacity that inhibits professionalism.
                    </blockquote>

                    <h5>Accepting and Giving Entertainment or Gifts</h5>
                    <blockquote id="orange">
                      Employees are not to give or accept any gifts, gratuities
                      or tips from clients, client’s families or any vendors.
                      Solicitation from a client, client’s family or vendors are
                      not permitted.
                    </blockquote>

                    <h5>Vacation</h5>
                    <blockquote id="orange">
                      All vacations must be requested and approved by the
                      employees immediate supervisor at least 4 weeks prior to
                      vacation start date, even if no PTO time is to be
                      utilized.
                    </blockquote>

                    <h5>Sick Leave</h5>
                    <blockquote id="orange">
                      The Company may require a physician’s note from an
                      employee in cases of absence in excess of two (2)
                      consecutive work days. A physician’s note may also be
                      required in cases where sick leave is being abused.
                    </blockquote>

                    <h5>Family and Medical Leave (FMLA)</h5>
                    <blockquote id="orange">
                      The FMLA entitles eligible employees of covered employers
                      to take unpaid, job-protected leave for specified family
                      and medical reasons. Eligible employees are entitled to
                      twelve (12) weeks of family and medical leave during any
                      twelve (12) month period for the following reasons:
                    </blockquote>
                    <ol id="blue">
                      <li>
                        The birth of the employee’s child and in order to care
                        for the child
                      </li>
                      <li>
                        The placement of a child with the employee for adoption
                        or foster care
                      </li>
                      <li>
                        To care for a spouse, child or parent of the employee
                        who has a serious health concern
                      </li>
                      <li>
                        A serious health condition which renders the employee
                        incapable of performing his/her job functions
                      </li>
                      <li>
                        An urgent need arising out of the fact that an
                        employee’s spouse, child or parent is called up for or
                        is on active duty in the Armed Forces in support of a
                        military contingency operation as defined by law and the
                        employee’s circumstances justify his/her need for leave
                      </li>
                    </ol>

                    <h5>Jury Duty</h5>
                    <blockquote id="orange">
                      Any absence for jury duty or subpoena as a witness in a
                      court hearing which the employee is not the plaintiff,
                      defendant or a voluntary witness shall be excused. The
                      wages paid by the Company during such an absence shall be
                      the regular rate less the fee paid by the court for such
                      service for a period of up to one month.
                    </blockquote>

                    <h5>Military Leave (USERRA)</h5>
                    <blockquote id="orange">
                      The Company grants leaves of absence to serve active duty
                      in the Armed Forces of the United States without pay. Upon
                      completion of active service, the employee may return to
                      the agency with the same level of seniority, status, pay
                      and benefits.
                    </blockquote>

                    <h5>Cell Phone & Telephone Use Policy</h5>
                    <blockquote id="orange">
                      Employees are required to follow all confidentiality
                      requirements as agreed stated in the Employer and Employee
                      Confidentiality Statement. Employees own electronic media
                      may only be used during breaks. This includes but is not
                      limited to personal phone calls, browsing social media,
                      text messaging, etc. Employees who misuse cell phones or
                      telephones are subject to disciplinary action up to and
                      including termination.
                    </blockquote>

                    <h5>Company Tools, Equipment, and Supplies</h5>
                    <blockquote id="orange">
                      The Company uses various forms of electronic communication
                      including, but not limited to: computers, email,
                      telephone, voicemail, instant messaging, group messaging
                      services, text message, internet, cell phones,
                      smartphones, etc which are hereafter referred to as
                      “electronic communications”. The electronic
                      communications, including all software, databases,
                      hardware and digital files, remain the sole property of
                      the Company and are to be used only for Company business
                      and not for personal use.
                    </blockquote>

                    <h5>Computer and Internet Use Policy</h5>
                    <blockquote id="orange">
                      Electronic communications and media may not be used in any
                      manner that would be considered discriminatory, harassing,
                      obscene, or for any purpose that is illegal, against
                      Company policy or not in the best interest of the Company.
                      Employees who misuse electronic communications are subject
                      to discipline up to and including termination.
                    </blockquote>

                    <h5>Blogging and Social Media Policy</h5>
                    <blockquote id="orange">
                      Disclosure of confidential information is grounds for
                      disciplinary action up to and including termination. All
                      statements to the press and/or social media concerning any
                      agency related material (incidents, policy, procedure or
                      client information) will be given only by the CEO or
                      Communications Department.
                    </blockquote>

                    <h5>Employee Conduct and Performance</h5>
                    <blockquote id="orange">
                      The Company has basic principles of integrity which serve
                      as guidelines regardless of job being fulfilled. The
                      Company expects its employees not to engage in any of the
                      following, including, but not limited to, activities which
                      may violate fraud, abuse, antitrust or environmental law.
                      The Company also deems the following conduct inappropriate
                      which may result in disciplinary action, up to and
                      including termination:
                    </blockquote>
                    <ol id="blue">
                      <li>Dishonesty or falsification of Company records</li>
                      <li>
                        Unauthorized use or possession of Company property
                      </li>
                      <li>
                        Possession of illegal drugs, weapons or other dangerous
                        materials
                      </li>
                      <li>Fighting or engaging in threats of violence</li>
                      <li>
                        Use of abusive language or other disorderly conduct
                      </li>
                      <li>
                        Failure to perform assigned duties or comply with
                        Company policies
                      </li>
                    </ol>
                    <h5>Immediate Employment Termination</h5>
                    <blockquote id="orange">
                      The Company is an at-will employer and may impose
                      discipline whenever it determines necessary or
                      appropriate. The Company may determine, at any time it is
                      appropriate, that an employee may be terminated
                      immediately.
                    </blockquote>

                    <h5>Progressive Discipline</h5>
                    <blockquote id="orange">
                      When an employee violates agency policy or procedures,
                      their supervisor is responsible for acting to correct the
                      situation. Progressive discipline (verbal warning, written
                      warning, suspension and termination) will be used on any
                      employee who violates Company policies or standards. The
                      method of discipline will be based on the severity of the
                      incident.
                    </blockquote>

                    <h5>Complaint Procedure & Conflict Resolution</h5>
                    <blockquote id="orange">
                      Employees are encouraged to speak with their supervisor
                      first. If the employee is not satisfied with the result or
                      feel they cannot approach their supervisor, they should be
                      presented to another member of Company management within
                      ten (10) day of the incident occurring. We will
                      investigate the complaint and, if needed, a meeting with
                      the parties involved will be conducted to discuss the
                      issue. Following the meeting, we will provide a written
                      response to all parties.
                    </blockquote>

                    <h5>Severe Weather and Emergency Closings</h5>
                    <blockquote id="orange">
                      In the event of a natural disaster or other emergency
                      closings, Program Managers will notify their BHPs, our
                      Office Manager will update our social media page and we
                      will offer resources such as hotline information for those
                      that may need it.
                    </blockquote>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(7)}
                    index={7}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Harassment and Discrimination
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(7)}>
                    <h5>Types of Harassment & Disciplinary Action:</h5>
                    <ol id="blue">
                      <li>
                        Sexual Harassment: Unlawful sexual harassment is when
                        and includes:
                      </li>
                      <ul>
                        <li>
                          Job benefits are granted on an employee’s agreement to
                          sexual demands or advances.
                        </li>
                        <li>
                          Job benefits are withheld based on an employee’s
                          refusal to agree to sexual advances or demands.
                        </li>
                        <li>
                          The working environment is oppressive to employees of
                          one sex
                        </li>
                        <li>
                          Threats that an employee’s refusal to sexual advances
                          will adversely affect the employee’s conditions of
                          employment or career
                        </li>
                        <li>
                          Sexual relations that an employee does not which
                          include unnecessary touching, patting, pinching,
                          brushing against or physical assault
                        </li>
                        Verbal harassment of a sexual nature which include
                        degrading comments, propositions, offensive or unwelcome
                        sexual flirtations, jokes or remarks about another
                        person’s clothing, body, appearance or sexual activities
                      </ul>
                      <li>
                        Other Harassment: Other unlawful harassment includes
                        derogatory remarks, slurs or actions targeting an
                        employee’s age, race, national origin, color, religion,
                        disability, sexual orientation or gender orientation.
                      </li>
                      <li>
                        Reporting Harassment: If an employee believes they have
                        encountered harassment from another employee,
                        supervisor, or other - that employee should report the
                        harassment immediately to a supervisor, member to
                        management or HR. After an investigation and review a
                        determination will be made as to whether the claim has
                        been substantiated.
                      </li>
                      <li>
                        Discipline for Harassment: If the claim has been
                        substantiated, the Company will take appropriate action
                        which may include termination.
                      </li>
                    </ol>
                    <p>
                      <i>
                        Harassment in any form is prohibited and may result in
                        disciplinary action up to and including termination.
                      </i>
                    </p>
                  </Accordion.Content>
                </Accordion>
              </Segment>
            </Segment.Group>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const ParentGuardianHandbook = (props) => {
  const { searchTerm } = useWikiSearch();
  const contentRef = useRef(null);
  useHighlightMatches(contentRef);

  return (
    <ParentGuardianHandbookClass
      {...props}
      searchTerm={searchTerm}
      contentRef={contentRef}
    />
  );
};

export default ParentGuardianHandbook;
